export default "__VITE_ASSET__Bs52xzr8__"